export default __webpack_public_path__ + "static/blob-19-77fd18d1eb7044e3e7f4abfb937e5645.svg";